/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_Cargando as Cargando,
  rec_ColoresMarca as ColoresMarca,
  rec_EstadoError as EstadoError,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_Fo as Fo,
  rec_Go as Go,
  rec_ImagenesMarca as ImagenesMarca,
  rec_JSXRuntime as JSXRuntime,
  rec_NombreMarca as NombreMarca,
  rec_React as React,
  rec_Ss as Ss,
  rec_TipografiaMarca as TipografiaMarca,
  rec_api as api,
  rec_gs as gs,
  rec_ji as ji,
  rec_tA as tA,
  rec_vs as vs,
} from "../../runtime/index.jsx";
export function Apariencia() {
  let e = Go(),
    { confirmar: t } = Fo(),
    [n, r] = (0, React.useState)(!0),
    [i, a] = (0, React.useState)(``),
    [o, s] = (0, React.useState)({
      cuerpo: [],
      titulos: [],
    }),
    [c, l] = (0, React.useState)(null),
    [u, f] = (0, React.useState)(null),
    [p, m] = (0, React.useState)(null),
    h = (0, React.useCallback)(async () => {
      r(!0);
      try {
        let [e, t] = await Promise.all([
          api(`/config/marca`),
          api(`/config/marca/fuentes`),
        ]);
        (l(e), f(e), m(tA(e)), s(t), a(``));
      } catch (e) {
        a(e.message);
      } finally {
        r(!1);
      }
    }, []);
  (0, React.useEffect)(() => {
    h();
  }, [h]);
  let g = (0, React.useRef)(null);
  ((0, React.useEffect)(() => {
    if (!p) return;
    let e = setTimeout(async () => {
      try {
        let e = await api(`/config/marca/vista-previa`, {
          method: `POST`,
          body: JSON.stringify(p),
        });
        (f(e), gs(e));
      } catch {}
    }, 250);
    return ((g.current = e), () => clearTimeout(e));
  }, [p]),
    (0, React.useEffect)(
      () => () => {
        let e = vs();
        (e && gs(e), Ss());
      },
      [],
    ));
  let _ = (0, React.useMemo)(
    () => !!p && !!c && JSON.stringify(p) !== JSON.stringify(tA(c)),
    [p, c],
  );
  async function v() {
    try {
      let t = await api(`/config/marca`, {
        method: `PUT`,
        body: JSON.stringify(p),
      });
      (l(t),
        f(t),
        gs(t),
        await Ss(),
        e.ok(`Listo, así se va a ver la aplicación`));
    } catch (t) {
      e.error(t.message);
    }
  }
  async function y() {
    if (
      await t({
        titulo: `Volver a los colores originales`,
        mensaje: `Se pierde lo que configuraste. Los logos que subiste se mantienen.`,
        confirmarTexto: `Volver al original`,
      })
    )
      try {
        let t = await api(`/config/marca`, {
          method: `DELETE`,
        });
        (l(t),
          f(t),
          m(tA(t)),
          gs(t),
          await Ss(),
          e.ok(`Volvió a los colores originales`));
      } catch (t) {
        e.error(t.message);
      }
  }
  return (
    <EstructuraPrincipal
      title={`Apariencia`}
      children={
        <div
          className={`animar-entrada flex flex-col gap-4`}
          children={[
            <p
              className={`text-sm text-(--text)`}
              children={`Cómo ven la aplicación las personas de tu empresa. Los cambios se ven mientras los hacés; recién se aplican para todos cuando guardás.`}
            />,
            <EstadoError mensaje={i} onReintentar={h} />,
            n || !p ? (
              <Cargando filas={4} />
            ) : (
              <JSXRuntime.Fragment
                children={[
                  <NombreMarca f={p} setF={m} />,
                  <ColoresMarca f={p} setF={m} previa={u} />,
                  <TipografiaMarca f={p} setF={m} fuentes={o} />,
                  <ImagenesMarca
                    marca={c}
                    onCambio={async () => {
                      (await h(), await Ss());
                    }}
                    avisos={e}
                    confirmar={t}
                  />,
                  <div
                    className={`sticky bottom-0 -mx-4 flex items-center gap-2 border-t border-(--border) bg-(--bg) px-4 py-3 sm:-mx-6 sm:px-6`}
                    children={[
                      <AccionAsync
                        variante={`texto`}
                        icono={ji}
                        onClick={y}
                        children={`Volver al original`}
                      />,
                      <span
                        className={`ml-auto text-xs text-(--text)`}
                        children={_ ? `Sin guardar` : `Todo guardado`}
                      />,
                      <AccionAsync
                        onClick={v}
                        disabled={!_}
                        textoOcupado={`Guardando…`}
                        children={`Guardar`}
                      />,
                    ]}
                  />,
                ]}
              />
            ),
          ]}
        />
      }
    />
  );
}
